<template>
    <router-view />
</template>
<script>
/* @71147 - aba nível tecnológico */
export default {
    beforeRouteUpdate(to, from, next) {
        if (to.name == 'agro-niveltecnologico') {
            next({ name: 'agro-niveltecnologico-list' });
        } else {
            next();
        }
    },
    created() {
        if (this.$route.name == 'agro-niveltecnologico') {
            this.$router.push({ name: 'agro-niveltecnologico-list' });
        }
    },
};
</script>
